import { useSelector } from "react-redux"
import { selectTranslations } from "../../../App/i18n/i18nSlice"
import "../../../Styles/main.scss"
import { LargeLogoIcon } from "../Components/SvgIcons"

function AuthPageDescription() {
    const translation = useSelector(selectTranslations)
    return (
        <div className="description-container">
            <>
            <h3 className=" description-container__small-text description-container__small-text--color-blue description-container__small-text--font-weight ">
                    <LargeLogoIcon/>
                </h3>
                <h1 className=" description-container__large-text description-container__large-text--color-gold description-container__large-text--font-weight">
                    <p>{translation.theOnlineCommunity} </p> <p>{translation.forEducation}</p>
                </h1>
            </>
            <>
                
            </>
        </div>
    )
}

export default AuthPageDescription
